import ErrorMessage from "lib/ErrorMessage";
import Image from "lib/Image";
import Label from "lib/Label";
import DatePicker from "react-date-picker";
import Calender from "assets/images/calender.svg";
import "./index.scss";
import { useState } from "react";
import { validateDOB } from "helper/validatedob";
import moment from "moment";
import "react-date-picker/dist/DatePicker.css";
import "react-calendar/dist/Calendar.css";
import { useSelector } from "react-redux";

const DobComponent = (props) => {
  const {
    name,
    value,
    label,
    class_name,
    error,
    placeholder,
    size,
    onChange,
    validators,
    disabled,
    selectedData,
    isEditable, // is used when RM requests to resend certain fields to the applicant
    // when editable is true only that field will be editable and rest will be disabled
  } = props;
  const IndirectEval = (evalString) => {
    // const selectedData = useSelector((state)=>state.formData.selectedData)
    return eval(evalString);
  };
  const guardianRecursive = useSelector((state) => state.guardianRecursive);

  const [showCalendar, setShowCalendar] = useState(false);
  const [date, setDate] = useState("");

  const minDate = new Date(1000, 0, 1); // January 1, 1000
  const errActive = error && error?.length !== 0;
  const errorClass = errActive ? "error_outline" : "";

  const handleChange = (newDate) => {
    if (newDate instanceof Date && !isNaN(newDate.getTime())) {
      const currentDate = new Date();
      if (newDate > currentDate) {
        newDate = currentDate; // Set newDate to current date if it's in the future
      }
      let isoDate = moment(newDate).format("DD/MM/YYYY");
      const res = validateDOB(newDate);
      setDate(newDate);
      onChange(res.majority, name, isoDate, res.age);
    }
  };

  let dateArray = [];
  let dataValue = value && value?.split("/");
  value && dateArray.push(dataValue[1]);
  value && dateArray.push(dataValue[0]);
  value && dateArray.push(dataValue[2]);

  return (
    <div className={size}>
      <Label label={label} validators={validators} />

      <div className="date_container">
        <DatePicker
          onChange={handleChange}
          format="dd/MM/yyyy"
          maxDate={new Date()}
          className={`input_date ${errorClass} ${class_name} ${
            !isEditable && "radioDisabled"
          }`}
          value={date ? date : value && new Date(`${dateArray.join("/")}`)}
          calendarIcon={
            <Image
              imageSrc={Calender}
              className="input_date_calender"
              onClick={(showCalendar) => setShowCalendar(!showCalendar)}
            />
          }
          minDate={minDate}
          isOpen={showCalendar}
          clearIcon={null}
          disabled={IndirectEval(disabled) ? true : isEditable ? false : true}
        />

        {error?.length !== 0 && <ErrorMessage error={error} />}
      </div>
    </div>
  );
};

export default DobComponent;
